import { GenericFormItem } from 'skyone-lib/lib/GenericForm/interfaces';

export default [
  {
    gridXs: 12,
    gridMd: 6,
    label: 'INSTANCE_ID_KEY',
    stateKey: 'instance_id',
    disabled: true,
  },
  {
    gridXs: 12,
    gridMd: 6,
    label: 'NAME_KEY',
    stateKey: 'name',
    disabled: true,
  },
  {
    gridXs: 6,
    gridMd: 6,
    label: 'PUBLIC_IP_KEY',
    stateKey: 'public_ip',
    disabled: true,
  },
  {
    gridXs: 6,
    gridMd: 6,
    label: 'PRIVATE_IP_KEY',
    stateKey: 'private_ip',
    disabled: true,
  },
  {
    gridXs: 6,
    gridMd: 3,
    label: 'FLAVOR_KEY',
    stateKey: 'flavor',
    disabled: true,
  },
] as GenericFormItem[];
